import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import Reveal from "../Reveal";

const faqs = [
  { q: "Quais serviços vocês oferecem?", a: "Oferecemos banho, tosa, tosa higiênica, higienização, corte de unhas e cuidados conforme a necessidade de cada pet." },
  { q: "Preciso agendar com antecedência?", a: "Sim! Recomendamos o agendamento pelo formulário do site ou WhatsApp para garantir o melhor horário e um atendimento mais tranquilo." },
  { q: "Quais formas de pagamento são aceitas?", a: "Aceitamos PIX, cartões de débito/crédito e dinheiro. Consulte as opções disponíveis na hora do agendamento." },
  { q: "Vocês atendem pets de qualquer porte?", a: "Sim, atendemos pets de diferentes portes, sempre respeitando o comportamento, a pelagem e as necessidades individuais de cada um." },
  { q: "Quanto tempo dura um banho e tosa?", a: "Em média, de 1h30 a 3h, dependendo do porte, tipo de pelagem e comportamento do pet. Tudo é feito com calma, cuidado e carinho." },
  { q: "Vocês têm leva e traz?", a: "Estamos avaliando esse serviço para a região. Entre em contato no WhatsApp para saber a disponibilidade na sua localidade." },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative overflow-hidden py-24 sm:py-32 text-white bg-transparent"
    >
      <div className="container-pad relative z-10 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <Reveal as="div" className="inline-block px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-xl border border-white/15 text-white text-xs font-bold uppercase tracking-[0.18em] mb-5">
            Perguntas frequentes
          </Reveal>

          <Reveal as="h2" delay={80} className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-[1.1]">
            Tirando suas <span className="italic text-gold">dúvidas</span>.
          </Reveal>

          <Reveal as="p" delay={140} className="mt-5 text-white/75 leading-relaxed">
            Se não encontrar o que procura aqui, fale com a gente no WhatsApp. Respondemos rapidinho. 🐾
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal
            as="div"
            delay={100}
            className="bg-white/10 backdrop-blur-2xl rounded-[32px] p-3 sm:p-5 border border-white/15 shadow-[0_35px_100px_rgba(0,0,0,.30)]"
          >
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  data-testid={`faq-${i}`}
                  className="border-b last:border-b-0 border-white/10"
                >
                  <AccordionTrigger className="text-left text-white font-heading text-lg font-semibold hover:no-underline px-3 py-5 hover:text-gold transition-colors">
                    {f.q}
                  </AccordionTrigger>

                  <AccordionContent className="px-3 pb-5 text-white/70 leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
